import { render, staticRenderFns } from "./DetailArea.vue?vue&type=template&id=40c1e9e8&scoped=true&"
import script from "./DetailArea.vue?vue&type=script&lang=js&"
export * from "./DetailArea.vue?vue&type=script&lang=js&"
import style0 from "./DetailArea.vue?vue&type=style&index=0&id=40c1e9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c1e9e8",
  null
  
)

export default component.exports